
// import TopHeaderBusiness from "../../../../components/general/TopHeaderBusiness";
// import AnalyticsTab from "./AnalyticsTabs/AnalyticsTabs";

// export default function Analytics(){
//     return(
//         <>
//         <TopHeaderBusiness/>
//        <AnalyticsTab/>
//         </>
//     )
// }


import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'

import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';

import TopHeaderBusiness from '../../../../components/general/TopHeaderBusiness';

import AnalyticsTab1 from './AnalyticsTabs/AnalyticsTab1/AnalyticsTab1';
import AnalyticsTab2 from './AnalyticsTabs/AnalyticsTab2/AnalyticsTab2';
import AnalyticsTab3 from './AnalyticsTabs/AnalyticsTab3/AnalyticsTab3';



export default function Analytics() {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));


    const [key, setKey] = useState('CUF Comparison');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    return (
        <Box>
            <CssBaseline />
            <TopHeaderBusiness />
            <Box mt={spacing(1)}>
                <Stack direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation" onClick={handleClick}>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {/* Business Dashboard */}
                    </NavLink>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {/* {location.pathname} */}
                    </NavLink>
                </Stack>
                <Tabs
                    style={{ justifyContent: "flex-end" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >



                    <Tab eventKey="CUF Comparison" title="CUF Comparison">

                        <AnalyticsTab2 />
                    </Tab>

                    <Tab eventKey="PR Comparison" title="PR Comparison">

                        <AnalyticsTab3 />
                    </Tab>

                    <Tab eventKey="General Comparison" title="General Comparison">

                        <AnalyticsTab1 />

                    </Tab>

                </Tabs>
            </Box>
        </Box>

    )
}
